import React from 'react';
import { isHelixOnlyHub } from 'utils/helix/isHelixOnlyHub';
import ErrorScreen from '../errors/ErrorScreen';
function HelixOnlyAccessWrapper(_ref) {
  var children = _ref.children;
  if (!isHelixOnlyHub) {
    return children;
  }
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    reason: "NO_ACCESS_TO_CONTENT"
  });
}
export default HelixOnlyAccessWrapper;